<div class="relative isolate flex h-full w-full max-lg:flex-col lg:overflow-hidden">
  <main [ngClass]="isLoggedIn ? 'lg:pl-32' : ''" class="flex flex-1 flex-col lg:min-w-0 overflow-hidden">
    <div [ngClass]="isLoggedIn ? 'h-full w-full lg:overflow-hidden' : ''">
      <router-outlet></router-outlet>
    </div>
  </main>
</div>

<!-- <ngx-ui-loader [fgsColor]="'#5046E4'" [pbColor]="'#5046E4'" [fgsType]="'fading-circle'"
  [fgsPosition]="'top-left'"></ngx-ui-loader> -->